<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import UserProfile from '../../../user/components/UserProfile.vue'

definePage({
  meta: {
    requiresAuth: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})
</script>

<template>
  <UserProfile />
</template>
